var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PrimaryButton',{class:_vm.buttonClass,on:{"click":_vm.buttonClicked}},[_vm._v(" "+_vm._s(_vm.button.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }